<template>
  <component :is="layout"></component>
</template>

<script>
import Login from './views/login.vue';
import Dashboard from './views/dashboard.vue';
import { mapState } from 'vuex';
import WsSubscriptions from './WsSubscriptions';
export default {
  name: 'app',
  components: {
    Login,
    Dashboard,
  },
  computed: mapState(['layout', 'login']),
  async beforeCreate() {
    await this.$store.dispatch('validateSessionUser', []);
  },
  async created() {
    await WsSubscriptions();
    // !this.login ? this.$router.push('/') : ''
  },
  beforeMount() {},
  mounted() {
    let protocol = window.location.protocol;
    //protocol === 'http:' ? this.$store.commit('SET_BASE_SOCKET', 'ws') : this.$store.commit('SET_BASE_SOCKET', 'wss')
  },
  methods: {},
};
</script>
